export default __webpack_public_path__ + "sdk-docs-icon@2x.png";